<template>
  <div id="app">
    <template v-if="loadingProcess">
      <app-icon
        name="oecko"
        size="large"
        desc="logo oecko"
        id="oecko-init-logo"
        color="#c7c7c7"
        @click="startDemo()" />
      <div id="loader">
        <Loader type="line" color="#c7c7c7"/>
      </div>
    </template>
    <template v-else>
      <router-view />
    </template>
  </div>
</template>

<style lang="sass" scoped>
#app
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale
  align-items: center
  background: $clear-background
  display: flex
  font-family: 'RobotoRegular'
  height: 100%
  justify-content: center
  overflow: hidden
  position: relative
  width: 100%
  #loader
    bottom: 1rem
    margin: auto
    position: absolute
  #app-background
    bottom: 0
    left: 0
    position: absolute
    right: 0
    top: 0
    img
      z-index: 0
</style>

<script>
import { mapGetters } from 'vuex';
import AppIcon from '@/components/icons/AppIcon.vue';
import Loader from '@/components/appModules/Loader.vue';

export default {
  name: 'app',

  components: {
    AppIcon,
    Loader,
  },

  data() {
    return {
      loadingProcess: true,
    };
  },

  computed: {
    ...mapGetters({
      socketMessage: 'getSocketMessage',
    }),
  },

  watch: {
    socketMessage(msg) {
      if (msg.type === 'init') {
        if (!localStorage.getItem('initConfig')) {
          localStorage.setItem(
            'initConfig',
            JSON.stringify({ deviceID: msg.deviceID, serverUrl: msg.oeckoServerUrl })
          );
          this.startScreen();
        } else {
          console.log('WS /');
        }
      }
    }
  },

  mounted() {
    this.startScreen();
  },

  methods: {
    startDemo() {
      localStorage.setItem(
        'initConfig',
        JSON.stringify({ deviceID: `rpi-demo-a82b68b6-d492-4869-ae69-${Date.now()}`, serverUrl: 'https://app.oecko.com' })
      );
      this.startScreen();
    },

    startScreen() {
      const version = process.env.VUE_APP_VERSION;
      let deviceID, serverUrl, registeredVersion;

      if (localStorage.getItem('initConfig')) {
        deviceID = JSON.parse(localStorage.getItem('initConfig')).deviceID;
        serverUrl = JSON.parse(localStorage.getItem('initConfig')).serverUrl;

        if (localStorage.getItem('registrationData')) {
          registeredVersion = JSON.parse(localStorage.getItem('registrationData')).registeredVersion;

          if (version !== registeredVersion) {
            // --- On passe à l'init pour aller mettre à jour l'enregistrement
            this.loadingProcess = false;
            this.$router.push({
              name: 'init',
              params: { operation: 'registration' }
            });
          } else {
            // --- affectation présente ??
            if (!localStorage.getItem('entranceConfig')) {
              // --- On passe à l'init pour aller s'occuper d'attendre l'affectation
              this.loadingProcess = false;
              this.$router.push({
                name: 'init',
                params: { operation: 'affectation' }
              });
            } else {
              // --- Pas besoin de repasser par l'init.
              this.loadingProcess = false;
              this.$router.push({
                name: 'launcher',
              });
            }
          }
        } else {
          // --- On passe à l'init pour aller s'enregistrer
          this.loadingProcess = false;
          this.$router.push({
            name: 'init',
            params: { operation: 'registration' }
          });
        }
      } else {
        // --- On reste là (pour l'instant)
        // --- Peut-être un écran en mode virtuel, démo, etc.
      }
    },
  },
};
</script>
